// RoleBasedRoute.js - Component to handle role-based access
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth/AuthContext';

// Component that requires a specific role to access
export const RoleBasedRoute = ({ requiredRole, redirectPath, children }) => {
  const { isAuthenticated, currentUser, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <div className="loading-container">Loading...</div>;
  }

  // Not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/profiles/login" />;
  }

  // Check if user has the required role
  const userRole = currentUser?.role || 'user';
  // superadmin can access everything an admin can
  const hasRequiredRole = requiredRole
    ? userRole === requiredRole || (requiredRole === 'admin' && userRole === 'superadmin')
    : true;

  // User doesn't have the required role, redirect to specified path
  if (!hasRequiredRole) {
    return <Navigate to={redirectPath || '/profiles/profile'} />;
  }

  // User has the required role, render the children
  return children;
};

// Dashboard redirect based on role
export const DashboardRedirect = () => {
  const { currentUser, isAuthenticated, isLoading } = useContext(AuthContext);
  
  if (isLoading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/profiles/login" />;
  }

  const userRole = currentUser?.role || 'user';
  
  // Redirect to appropriate dashboard based on role
  if (userRole === 'admin' || userRole === 'superadmin') {
    return <Navigate to="/profiles/admin" />;
  } else {
    return <Navigate to="/profiles/profile" />;
  }
};